module.exports = __webpack_public_path__ + "img/105.42d5836c.jpg";